import { Language } from '../ts/customTypes';
import { Pages } from '../ts/customTypes';

// Background

// Icons
import IconBenefits from '../icons/content/benefits.svg';

// Content Images
import processStepTeileidentifikation1Svg from '../content/fr/process-parts-identification-step1.svg';
import processStepTeileidentifikation2Svg from '../content/fr/process-parts-identification-step2.svg';
import processStepTeileidentifikation3Svg from '../content/fr/process-parts-identification-step3.svg';
import processStepTeileidentifikation4Svg from '../content/fr/process-parts-identification-step4.svg';

import processStepLagerergaenzung1Svg from '../content/fr/process-storage-step1.svg';
import processStepLagerergaenzung2Svg from '../content/fr/process-storage-step2.svg';
import processStepLagerergaenzung3Svg from '../content/fr/process-storage-step3.svg';
import processStepLagerergaenzung4Svg from '../content/fr/process-storage-step4.svg';

import contactImage from '../content/mail-contact.png';
import testimonial1 from '../content/testimonial1.jpg';
import testimonial2 from '../content/testimonial2.jpg';
import { IconBestellschnittstelle } from '../../lib/components/content/IconBestellschnittstelle';
import { IconKatalogschnittstelle } from '../../lib/components/content/IconKatalogschnittstelle';
import { IconVerfuegbarkeitsschnittstelle } from '../../lib/components/content/IconVerfuegbarkeitsschnittstelle';
import { IconNettopreisschnittstelle } from '../../lib/components/content/IconNettopreisschnittstelle';

import landingpageSmallImage1 from '../content/landingpage-img-1.webp';
import landingpageSmallImage2 from '../content/landingpage-img-2.webp';
import landingpageBigImage from '../content/image-landingpage-big.jpg';

import imageKatalogschnittstelle from '../content/image-katalogschnittstelle.jpg';
import imageBestellschnittstelle from '../content/image-bestellschnittstelle.jpg';
import imageNettopreisschnittstelle from '../content/image-nettopreisschnittstelle.jpg';
import imageVerfuegbarkeitsschnittstelle from '../content/image-verfuegbarkeitsschnittstelle.jpg';
import flag from '../flags/flag-fr.svg';

export const fr: Language = {
    id: 'FR',
    languageName: 'Français',
    flagUrl: flag,
    headerHeading: 'eProcurement',
    backToLandingPageLabel: 'Aperçu',
    infolayer: {
        text: (
            <>
                <p>Nous sommes heureux que vous souhaitiez en savoir plus sur les interfaces OMNIplus eProcurement.</p>
                <p>
                    Le site web est optimisé pour être affiché sur un ordinateur de bureau ou une tablette. Il n’est
                    malheureusement pas possible de l’afficher sur votre appareil mobile.
                </p>
                <p>
                    L’adresse web de cette page vous permet également d’ouvrir les contenus sur d’autres appareils. Il
                    suffit d’envoyer l’adresse de cette page à une tablette ou à votre ordinateur. Cliquez sur le lien
                    suivant pour copier l’adresse web dans le presse-papiers :
                </p>
            </>
        ),
        button: 'Copier le lien dans le presse-papiers',
    },
    [Pages.LANDINGPAGE]: {
        headline: 'Processus d’achat',
        headlineWidth: 450,
        buttonContact: 'Contact',
        buttonTestimonials: 'Avis des clients',
        tooltips: {
            availability: 'Interface de disponibilité',
            catalogue: 'Interface catalogue',
            identification: 'Identification des pièces',
            order: 'Interface de commande',
            price: 'Interface prix nets',
            storage: 'Planification des\npièces de rechange\nconnues',
        },
        background: '',
        images: {
            leftUpper: landingpageSmallImage1,
            leftLower: landingpageSmallImage2,
            big: landingpageBigImage,
        },
    },
    testimonialsPage: {
        headline: 'Avis des clients',
        headlineWidth: 430,
        testimonials: [
            {
                name: 'Jens-Uwe Mentel',
                imageUrl: testimonial1,
                job: 'Collaborateur technique chez Usedomer Bäderbahn GmbH',
                quotes: [
                    '« La mise en place de la nouvelle interface avec COSware a bien fonctionné. Cela nous permet désormais d’intégrer les pièces de rechange dans le système et de les commander plus efficacement et plus rapidement. »',
                ],
            },
            {
                name: 'Mirano Bitici',
                job: 'Responsable du service des achats chez Stuttgarter Straßenbahnen AG',
                quotes: [
                    '« En très peu de temps, un projet a été mis en place pour réaliser la connexion de notre système d’approvisionnement avec OMNIplus »',
                    '« Il convient de souligner la démarche pragmatique et efficace. »',
                    '« Aujourd’hui, nous bénéficions de la baisse des coûts d’approvisionnement dans les achats et dans nos ateliers. »',
                ],
            },
            {
                name: 'Richard Schallmoser',
                imageUrl: testimonial2,
                job: 'Achats chez Holding Graz - Kommunale Dienstleistungen GmbH',
                quotes: [
                    '« Avec la mise en œuvre, nous avons également optimisé le processus d’achat dans l’environnement. Pour nous, cet avantage secondaire était aussi important que les interfaces elles-mêmes. »',
                    '« En très peu de temps, la connexion s’est avérée si efficace qu’elle est devenue incontournable. »',
                ],
            },
        ],
        footer: {
            headline: 'Nos interfaces sont utilisées pour :',
            companies: [
                'Stuttgarter Straßenbahnen AG',
                'Holding Graz – Kommunale Dienstleistungs GmbH',
                'Regionalbus Leipzig GmbH',
                'Usedomer Bäderbahn GmbH',
                'EBS Public Transportation B. V.',
            ],
        },
    },
    contactPage: {
        headline: 'Contact',
        headlineWidth: 250,
        texts: [
            'Lors de la mise en œuvre des interfaces d’approvisionnement en ligne, vos processus sont au centre de vos préoccupations : C’est pourquoi nous vous soutenons dans votre projet de connexion personnalisé pour la numérisation de votre approvisionnement.',
            'N’hésitez pas à nous contacter au :',
        ],
        email: 'omniplus-eprocurement@daimlertruck.com',
        imageUrl: contactImage,
        stepsHeadline: 'En règle générale, chaque projet d’interfaçage se déroule en quatre étapes :',
        steps: ['Lancement', 'Conception', 'Implémentation', 'Mise en service'],
        text: (
            <p>
                Après avoir pris contact avec nous, un coup d’envoi déterminera comment eProcurement peut
                potentiellement vous aider dans votre processus d’achat. Ensuite, la phase de conception examine comment
                et avec quel effort la mise en œuvre peut se dérouler. Après une phase de testing réussie, il est
                possible de passer au nouveau processus d’achat.
            </p>
        ),
    },
    infoPages: {
        [Pages.VERFUEGBARKEITSSCHNITTSTELLE]: {
            headline: 'Interface de disponibilité',
            icon: <IconVerfuegbarkeitsschnittstelle />,
            intro: 'Appel des disponibilités de vos pièces de rechange commandées directement dans votre système client via l’interface.',
            text: (
                <p>
                    L’interface de disponibilité vous permet de consulter les quantités disponibles pour vos pièces de
                    rechange nécessaires. Vous pouvez non seulement consulter la disponibilité de votre point de service
                    OMNIplus, mais aussi la totalité de la chaîne d’approvisionnement.
                </p>
            ),
            infoBoxes: [
                {
                    icon: IconBenefits,
                    headline: 'Vos avantages',
                    list: [
                        'Transparence totale sur les quantités de livraison disponibles auprès de votre point de service OMNIplus',
                        'Affichage de la disponibilité sur l’ensemble de la chaîne logistique',
                        'Meilleure planification du processus d’approvisionnement',
                        'Appel via une interface API REST',
                    ],
                },
            ],
            images: {
                main: imageVerfuegbarkeitsschnittstelle,
            },
        },
        [Pages.BESTELLSCHNITTSTELLE]: {
            headline: 'Interface de commande',
            icon: <IconBestellschnittstelle />,
            intro: 'Envoyer les commandes directement à OMNIplus.',
            text: (
                <p>
                    L’intégration d’une interface de commande permet de transmettre les ordres de commande directement
                    au système OMNIplus. Ainsi, lors de la commande dans le système client, il n’y a pas de rupture du
                    système et le transfert manuel du contenu de la commande est supprimé afin que la commande soit
                    traitée plus rapidement et exactement comme elle a été transmise. Il est actuellement possible
                    d’établir une connexion via une interface avec les propres centres de service de Daimler Buses avec
                    classification BusWorld.
                </p>
            ),
            infoBoxes: [
                {
                    icon: IconBenefits,
                    headline: 'Vos avantages',
                    list: [
                        'Approvisionnement numérique en pièces de rechange sans interruption du système',
                        'Traitement plus rapide de la commande grâce à la création directe de la commande dans Daimler Buses Service Center',
                        'Possibilité de transmission d’une confirmation de commande via l’interface',
                        'Diversité des connexions : Connexion possible via normes EDI, cXML ou une interface API REST',
                    ],
                },
            ],
            images: {
                main: imageBestellschnittstelle,
            },
        },
        [Pages.KATALOGSCHNITTSTELLE]: {
            headline: 'Interface catalogue',
            icon: <IconKatalogschnittstelle />,
            intro: 'Identification facile des pièces de rechange nécessaires sans quitter le système du client.',
            text: (
                <p>
                    Une interface catalogue permet d’identifier les pièces de rechange dans l’OMNIplus eShop et de les
                    transférer dans le système client. Dans le catalogue OMNIplus eShop, vous pouvez consulter vos prix
                    personnalisés ainsi que la disponibilité auprès de votre point de service OMNIplus.
                </p>
            ),
            infoBoxes: [
                {
                    icon: IconBenefits,
                    headline: 'Vos avantages',
                    list: [
                        'Intégration du parc automobile spécifique au client dans l’OMNIplus eShop',
                        'Disponibilités et prix personnalisés directement visibles',
                        'Recherche de pièces de rechange via quatre manières différentes, par exemple via la documentation du véhicule dans BusParts Catalog',
                        'Prise en charge des normes OCI et cXML',
                    ],
                },
            ],
            images: {
                main: imageKatalogschnittstelle,
            },
        },
        [Pages.NETTOPREISSCHNITTSTELLE]: {
            headline: 'Interface prix nets',
            icon: <IconNettopreisschnittstelle />,
            intro: 'Appel de vos prix de pièces de rechange spécifiques au client directement dans votre système client via l’interface.',
            text: (
                <>
                    <p>
                        L’interface de prix net vous permet de transférer les prix de vos pièces de rechange directement
                        du système OMNIplus dans votre système client. Vos conditions et actions spéciales
                        personnalisées sont prises en compte. La demande de prix est possible dans tous les centres de
                        service Daimler Buses disposant d’une classification BusWorld.
                    </p>
                </>
            ),
            infoBoxes: [
                {
                    icon: IconBenefits,
                    headline: 'Vos avantages',
                    list: [
                        'Affichage du prix en tenant compte de vos conditions individuelles pour les pièces de rechange attribuées',
                        'Transparence totale des prix, même en cas de prix spéciaux et de remises échelonnées',
                        'Processus de commande et de validation entièrement possible dans le système client',
                        'Appel via une interface API REST',
                    ],
                },
            ],
            images: {
                main: imageNettopreisschnittstelle,
            },
        },
    },
    processPages: {
        [Pages.TEILEIDENTIFIKATION]: {
            headline: 'Identification des pièces via l’interface du catalogue',
            headlineWidth: 820,
            infoBox: {
                headline: 'Type d’utilisation',
                bullets: [
                    'Vous recherchez une pièce de rechange pour votre véhicule, sachant que vous ne connaissez pas la référence à commander. Par exemple, parce qu’il s’agit d’un nouveau modèle de véhicule ou que la pièce de rechange nécessaire n’est pas enregistrée dans votre base de données client.',
                ],
            },
            steps: [
                {
                    imageUrl: processStepTeileidentifikation1Svg,
                    headline: 'Appel du catalogue OMNIplus eShop',
                    content: (
                        <>
                            Le catalogue OMNIplus eShop peut être consulté dans votre système de gestion des
                            marchandises propre au client afin de démarrer l’identification des pièces de rechange.
                        </>
                    ),
                },
                {
                    imageUrl: processStepTeileidentifikation2Svg,
                    headline: 'Identification des pièces via OMNIplus eShop',
                    content: (
                        <>
                            Dans l’interface eShop, il est possible d’identifier la pièce de rechange nécessaire de
                            quatre manières différentes. En plus de l’intégration du parc de véhicules individuel, la
                            boutique en ligne propose par exemple également la recherche de pièces de rechange via la
                            documentation du véhicule dans BusParts Catalog.
                        </>
                    ),
                },
                {
                    imageUrl: processStepTeileidentifikation3Svg,
                    headline: 'Transfert dans le système client',
                    content:
                        'Après l’identification des pièces de rechange nécessaires et la composition d’un panier d’achat, les informations pièces peuvent être transférées de l’OMNIplus eShop dans le système client.',
                },
                {
                    imageUrl: processStepTeileidentifikation4Svg,
                    headline: 'Commande à partir du système client',
                    content: (
                        <>
                            Votre commande est transmise au système OMNIplus en un clic via l’interface de commande et
                            peut être traitée directement.
                        </>
                    ),
                },
            ],
        },
        [Pages.LAGERERGAENZUNG]: {
            headline:
                'Planification des pièces de rechange connues à l’aide de l’interface de disponibilité et de prix',
            headlineWidth: 1410,
            infoBox: {
                headline: 'Type d’utilisation',
                bullets: [
                    'Dans de nombreux cas, vous connaissez déjà les pièces de rechange dont vous avez besoin.',
                    'C’est par exemple le cas lorsque l’identification des pièces de rechange a déjà eu lieu à l’atelier et qu’un ordre de commande avec les références nécessaires est créé dans votre système.',
                    <>
                        Vous pouvez également recevoir un message dans votre système de gestion des marchandises vous
                        informant que le stock minimal de pièces individuelles n’est pas atteint. Si les numéros de
                        fournisseur sont déjà gérés dans la base de données articles, vous pouvez demander un complément
                        de stock dans ce qui suit.
                    </>,
                ],
            },
            steps: [
                {
                    imageUrl: processStepLagerergaenzung1Svg,
                    headline: 'Ordonnancement des pièces de rechange à acheter', // #AB1-Disposition-eProcurement-Click-Explainer#
                    content:
                        'Dans votre système de gestion des marchandises, vous planifiez les pièces de rechange nécessaires dans un ordre de commande, par exemple pour effectuer des compléments de stock.',
                },
                {
                    imageUrl: processStepLagerergaenzung2Svg,
                    headline: 'Appel de la disponibilité et du prix',
                    content: (
                        <>
                            Après la création d’un ordre de commande dans votre système client avec les pièces de
                            rechange à acheter, vous pouvez appeler les disponibilités et prix correspondants via
                            l’interface eProcurement.
                        </>
                    ),
                },
                {
                    imageUrl: processStepLagerergaenzung3Svg,
                    headline: 'Vérification du bon de commande',
                    content:
                        'Dans votre système client, vous pouvez afficher les informations appelées sur les pièces de rechange attribuées et, le cas échéant, lancer vos processus internes de validation.',
                },
                {
                    imageUrl: processStepLagerergaenzung4Svg,
                    headline: 'Commande à partir du système client',
                    content:
                        'Vous pouvez ensuite transmettre votre commande au système OMNIplus via l’interface de commande afin que celle-ci puisse être traitée directement.',
                },
            ],
        },
    },
};
